import { withProps, compose, setDisplayName } from "recompose";
import { toNumber, isEmpty } from "lodash";

const calcTotalPrice = (total, item) =>
  item.type_service === "for_hours" ? total + toNumber(item.part_price) : total;
const calcTotalFlatFee = (total, item) =>
  item.type_service === "flat_fee" ? total + toNumber(item.flat_fee) : total;
const calcTotalHours = labor_rate => (total, item) =>
  item.type_service === "for_hours"
    ? total + toNumber(item.labor_time) * toNumber(labor_rate) || 0
    : total;
const allAre = type => (is, item) => is && item.stage === type;

const withTotals = withProps(
  ({ contract, discounts, items, showDiscount, showExpress }) => {
    if (contract) {
      const {
        express: is_express,
        was_express,
        labor_rate,
        dealer: { express_rate, express_rate_type }
      } = contract;
      let express = is_express || was_express;
      let totalHours = items.reduce(calcTotalHours(labor_rate), 0);
      let totalParts = items.reduce(calcTotalPrice, 0);
      let totalFlatFee = items.reduce(calcTotalFlatFee, 0);
      let subTotal = totalHours + totalParts + totalFlatFee;
      let expressAmount = showExpress
        ? toNumber(
            express_rate_type === "flat"
              ? express_rate
              : subTotal * (toNumber(express_rate) / 100)
          )
        : 0;
      let confirmed = isEmpty(items)
        ? false
        : items.reduce(allAre("confirmed"), true);
      let completed = isEmpty(items)
        ? false
        : items.reduce(allAre("completed"), true);
      let servicesTotal =
        subTotal + (express && (confirmed || completed) ? expressAmount : 0);
      let totalDiscount =
        isEmpty(discounts) && !showDiscount
          ? 0
          : discounts.reduce(
              (total, { discount_type, quantity }) =>
                discount_type === "flat"
                  ? (total += toNumber(quantity))
                  : (total += servicesTotal * (toNumber(quantity) / 100)),
              0
            );
      let appliedDiscount = false;
      // const withDiscount = totalDiscount => {
      //   appliedDiscount = true;
      //   return totalDiscount;
      // };
      return {
        totalHours,
        totalParts,
        totalFlatFee,
        subTotal,
        expressAmount,
        express,
        servicesTotal,
        totalDiscount,
        finalTotal: servicesTotal - (totalDiscount > servicesTotal ? 0 : totalDiscount),
        confirmed,
        completed,
        appliedDiscount
      };
    } else {
      return {};
    }
  }
);

export default compose(
  setDisplayName("WithTotals"),
  withTotals
);
